/**
 * 사업 유형(분류축 CATEGORY) 아이콘 — 화면 전용 장식만 둔다.
 * 유형의 값 집합·표시명·순서 SSoT 는 `advisordesk.taxonomy_node`(axis=CATEGORY) 노드다(specs/033) — 표시명은 서버 응답
 * (`categoryName`·필터 옵션 `name`·facet `categoryNames`)에서 받고, 여기에 라벨을 두지 않는다.
 * 노드가 새로 생기면 아이콘 등록 없이도 기본 아이콘으로 보인다(필요하면 이 표에 추가).
 */
import {
  Banknote,
  BriefcaseBusiness,
  ClipboardCheck,
  FlaskConical,
  Globe,
  GraduationCap,
  Network,
  Rocket,
  Store,
  Tag,
  Warehouse,
  type LucideIcon,
} from 'lucide-react';

/** CATEGORY 노드 code — 노드가 늘 수 있어 열린 문자열이다. */
export type ProgramCategoryCode = string;

const PROGRAM_CATEGORY_ICONS: Record<ProgramCategoryCode, LucideIcon> = {
  BIZ: Rocket,
  RND: FlaskConical,
  FACILITY: Warehouse,
  MENTORING: GraduationCap,
  EVENT: Network,
  LOAN: Banknote,
  HR: BriefcaseBusiness,
  GLOBAL: Globe,
  MANAGEMENT: ClipboardCheck,
  MARKET: Store,
};

/** 아이콘 미등록 유형의 기본 아이콘. */
export const DEFAULT_CATEGORY_ICON: LucideIcon = Tag;

export function categoryIcon(code: ProgramCategoryCode): LucideIcon {
  return PROGRAM_CATEGORY_ICONS[code] ?? DEFAULT_CATEGORY_ICON;
}

/** 관심 유형 기본값 — 경영지도사가 가장 많이 찾는 자금(융자·보증). 사용자가 바꾸거나 끌 수 있다. */
export const DEFAULT_FAVORITE_CATEGORY: ProgramCategoryCode = 'LOAN';

/** 저장값 형식 검사 — 노드에 실제로 있는지는 화면이 서버 옵션과 대조해 판단한다(없는 code 는 관심 유형 미설정처럼 보인다). */
export function isProgramCategoryCode(v: unknown): v is ProgramCategoryCode {
  return typeof v === 'string' && v.trim() !== '';
}
